export default __webpack_public_path__ + "static/media/setting.e74ee4f8.png";